"use strict";
// @ts-ignore
Object.defineProperty(exports, "__esModule", { value: true });
exports.printer = exports.BasePrinter = void 0;
const DateComponent_1 = require("./components/DateComponent");
const TimeComponent_1 = require("./components/TimeComponent");
const UptimeComponent_1 = require("./components/UptimeComponent");
const FileComponent_1 = require("./components/FileComponent");
const FunctionComponent_1 = require("./components/FunctionComponent");
const ColumnComponent_1 = require("./components/ColumnComponent");
const LineComponent_1 = require("./components/LineComponent");
const ansi_styles_1 = require("ansi-styles");
const TagComponent_1 = require("./components/TagComponent");
const utils_1 = require("./utils");
const CallbackComponent_1 = require("./components/CallbackComponent");
const NamespaceComponent_1 = require("./components/NamespaceComponent");
const supports_color_1 = require("supports-color");
const color_name_1 = require("color-name");
let glob_;
if (typeof global !== "undefined")
    glob_ = global;
else if (typeof window !== "undefined")
    glob_ = window;
else if (typeof self !== "undefined")
    glob_ = self;
else if (typeof globalThis !== "undefined")
    glob_ = globalThis;
else
    glob_ = {};
const globalVar = glob_;
const isReactNative = typeof glob_.navigator !== "undefined" && glob_.navigator["product"] === "ReactNative";
const isWeb = (typeof window !== "undefined" || typeof self !== "undefined" || isReactNative) && typeof process === "undefined";
// const hasAnsi256Stdout = supportsColor.stdout && supportsColor.stdout.has256;
const hasAnsi16mStdout = supports_color_1.default.stdout && supports_color_1.default.stdout.has16m;
// const hasAnsi256Stderr = supportsColor.stderr && supportsColor.stderr.has256;
// const hasAnsi16mStderr = supportsColor.stderr && supportsColor.stderr.has16m;
let req;
try {
    req = eval("require");
}
catch (e) {
    req = () => null;
}
let nodeUtil = null;
try {
    if (typeof process !== "undefined" && process.versions?.node) {
        // eslint-disable-next-line
        // @ts-ignore
        Promise.resolve(`${JSON.parse('"util"')}`).then(s => require(s)).then(util => nodeUtil = util).catch(() => void 0);
    }
    // eslint-disable-next-line
}
catch {
}
let originalConsole = typeof console !== "undefined" ? console : null;
const ExtraOptions = {
    componentSymbol: "$",
    allowSubstitutions: true,
    allowTextSubstitutions: false,
    namespaceValue: "",
    format: "$namespace$date $time $tag $text",
    end: "\n",
    sep: " ",
    currentTag: null,
    objectDepth: 2,
    defaultTag: "log",
    defaultWarnTag: "warn"
};
var LogLevel;
(function (LogLevel) {
    LogLevel["log"] = "log";
    LogLevel["info"] = "info";
    LogLevel["warn"] = "warn";
    LogLevel["error"] = "error";
    LogLevel["debug"] = "debug";
})(LogLevel || (LogLevel = {}));
const DefaultTagOptions = {
    level: LogLevel.log
};
const periodicLogger = {};
const streamsLength = new Map;
const clearString = "\x1b[2J\x1b[0;0H";
class BasePrinter {
    defaultStream = (text, clean, level) => {
        if (isWeb) {
            if (text === clearString)
                return originalConsole.clear();
            originalConsole[this._tracing ? "trace" : level](text);
        }
        else {
            const out = globalVar.process[level === LogLevel.error ? "stderr" : "stdout"];
            const lineLength = streamsLength.get(out) || 0;
            const info = this.readInfo;
            if (info) {
                if (lineLength !== 0)
                    out.write(`\r\x1b[1A\x1b[${lineLength}C`); // up(1), right(oldLineLength)
                else
                    out.write(`\r${" ".repeat(info.question.length + info.text.length)}\r`); // clear
            }
            const lineIndex = text.lastIndexOf("\n");
            streamsLength.set(out, text.length - lineIndex - 1);
            out.write(text);
            if (info) {
                if (lineIndex !== text.length - 1)
                    out.write("\n");
                out.write(info.question + info.text);
            }
        }
    };
    tags = {};
    components = {};
    componentNames = []; // sorted so the longest component names are first
    substitutions = {};
    parsed = [];
    parsedComponents = new Set;
    streams = new Map([[this.defaultStream, this.defaultStream]]);
    _periodicOptions;
    _inline;
    palette = {};
    alreadyReading = null;
    readInfo = null;
    _counts = {};
    _times = {};
    _group = 0;
    _tracing = false;
    get inline() {
        if (this.options.end === "")
            return this;
        this._inline ??= this.create();
        this._inline.options.end = "";
        return this._inline;
    }
    ;
    get brackets() {
        return brackets;
    }
    ;
    options = { ...ExtraOptions };
    setOptions(value) {
        for (const key in value)
            if (this.components[key]) {
                const val = value[key];
                if (!val || typeof val !== "object")
                    continue;
                Object.assign(this.options[key], val);
            }
            else
                this.options[key] = value[key];
        this.parse();
        return this;
    }
    ;
    getTags() {
        return Object.keys(this.tags);
    }
    ;
    getTag(name) {
        if (!this.tags[name])
            throw new Error(`Tag "${name}" does not exist.`);
        return this.tags[name];
    }
    ;
    hasTag(name) {
        return name in this.tags;
    }
    ;
    getComponents() {
        return this.componentNames;
    }
    ;
    hasComponent(name) {
        return this.componentNames.includes(name);
    }
    ;
    getComponent(component) {
        return this.components[component];
    }
    ;
    getComponentValue(name) {
        const component = this.getComponent(name);
        if (!component)
            throw new Error(`Component "${name.toString()}" does not exist.`);
        const opts = this.options[name];
        const st = opts;
        let text = component.get(opts, this);
        if (!text)
            return ["", ""];
        text = this.applySubstitutions(text);
        const cleaned = this.cleanSubstitutions(text);
        if (st.padding)
            text = " ".repeat(st.padding) + text + " ".repeat(st.padding);
        if (st.background)
            text = this.color(st.background, true) + text;
        if (st.color)
            text = this.color(st.background, true) + text;
        if (st.italic)
            text = ansi_styles_1.default.italic.open + text;
        if (st.underline)
            text = ansi_styles_1.default.underline.open + text;
        if (st.strikethrough)
            text = ansi_styles_1.default.strikethrough.open + text;
        if (st.bold)
            text = ansi_styles_1.default.bold.open + text;
        if (st.background || st.color || st.italic || st.underline || st.strikethrough || st.bold)
            text += ansi_styles_1.default.reset.open;
        return [text, cleaned];
    }
    ;
    parse() {
        let format = this.options.format;
        if (typeof format === "function")
            format = format(this)[0];
        const symbol = this.options.componentSymbol;
        const parsed = this.parsed;
        parsed.length = 0;
        const comps = this.parsedComponents;
        comps.clear();
        const spl = format.split(symbol);
        if (spl[0])
            parsed.push(spl[0]);
        const components = this.getComponents();
        for (let i = 1; i < spl.length; i++) {
            const sp = spl[i];
            if (sp.startsWith("text")) {
                parsed.push(null);
                parsed.push(sp.slice("text".length));
                continue;
            }
            let found = false;
            for (const name of components) {
                if (sp.startsWith(name)) {
                    comps.add(name);
                    parsed.push({ name, comp: this.getComponent(name) });
                    parsed.push(sp.slice(name.length));
                    found = true;
                    break;
                }
            }
            if (!found)
                parsed.push(symbol + sp);
        }
    }
    ;
    applySubstitutions(text) {
        if (!this.options.allowSubstitutions)
            return text;
        for (const name in this.substitutions) {
            const sub = this.substitutions[name];
            text = text.replaceAll(name, typeof sub === "string" ? sub : sub(this));
        }
        return text;
    }
    ;
    cleanSubstitutions(text) {
        if (!this.options.allowTextSubstitutions)
            return text;
        for (const name in this.substitutions)
            text = text.replaceAll(name, "");
        return text;
    }
    ;
    tag(name, ...args) {
        const tag = this.tags[name];
        this.options.currentTag = tag;
        if (tag.assert) {
            if (args.length === 0)
                throw new Error(`Tag "${name}" requires a message.`);
            if (args[0])
                return;
            args.splice(0, 1);
            if (args.length === 0)
                args.push("Assertion failed.");
        }
        let result = this.format(...args)[0];
        const lines = result.split("\n");
        const isNormalText = tag.textColor && ((tag.level !== LogLevel.error && tag.level !== LogLevel.warn) || !isWeb);
        let result2 = "";
        let cleanResult2 = "";
        for (let i = 0; i < lines.length; i++) {
            const text = lines[i];
            const group = "  ".repeat(this._group);
            result2 += group;
            cleanResult2 += group;
            for (let i = 0; i < this.parsed.length; i++) {
                const part = this.parsed[i];
                if (typeof part === "string") {
                    cleanResult2 += this.cleanSubstitutions(part);
                    result2 += this.applySubstitutions(part);
                }
                else if (!part) {
                    if (isNormalText)
                        result2 += this.color(tag.textColor);
                    result2 += this.options.allowTextSubstitutions ? this.applySubstitutions(text) : text;
                    cleanResult2 += this.options.allowTextSubstitutions ? this.cleanSubstitutions(text) : text;
                    if (isNormalText)
                        result2 += ansi_styles_1.default.reset.open;
                }
                else {
                    const [comp, cleanComp] = this.getComponentValue(part.name);
                    result2 += comp;
                    cleanResult2 += cleanComp;
                }
            }
            result2 += this.options.end;
            cleanResult2 += this.options.end;
        }
        this.write(result2, cleanResult2, tag.level || LogLevel.log);
    }
    ;
    write(text, cleanText, level) {
        for (const fn of this.streams.values())
            fn(text, cleanText, level, this);
    }
    ;
    addTag(name, options) {
        if (this.tags[name])
            throw new Error(`Tag "${name}" already exists.`);
        this.tags[name] = { ...DefaultTagOptions, ...options };
        // @ts-ignore
        this[name] = (...args) => this.tag(name, ...args);
        return this;
    }
    ;
    removeTag(...names) {
        for (const name of names) {
            if (typeof name !== "string")
                continue;
            if (!this.tags[name])
                throw new Error(`Tag "${name}" does not exist.`);
            delete this.tags[name];
            delete this[name];
        }
        return this;
    }
    ;
    addComponent(name, component) {
        if (this.components[name])
            throw new Error(`Component "${name}" already exists.`);
        if (component instanceof Function)
            component = new CallbackComponent_1.default(component);
        this.components[name] = component;
        this.componentNames.push(name);
        this.componentNames.sort((a, b) => b.length - a.length);
        this.options[name] = { ...component.defaultOptions };
        this.parse();
        return this;
    }
    ;
    removeComponent(...name) {
        for (const key of name) {
            if (typeof key !== "string" || !this.components[key])
                continue;
            delete this.components[key];
            const index = this.componentNames.indexOf(key);
            if (index !== -1)
                this.componentNames.splice(index, 1);
            delete this.options[key];
        }
        this.parse();
        return this;
    }
    ;
    addSubstitution(name, style) {
        if (this.substitutions[name])
            throw new Error(`Substitution "${name}" already exists.`);
        this.substitutions[name] = style;
        this.parse();
        return this;
    }
    ;
    removeSubstitution(name) {
        if (!this.substitutions[name])
            throw new Error(`Substitution "${name}" does not exist.`);
        delete this.substitutions[name];
        this.parse();
        return this;
    }
    ;
    addStyle(name, css) {
        return this.addSubstitution(name, typeof css === "string" ? ansi_styles_1.default.reset.open + this.css(css) : (printer) => ansi_styles_1.default.reset.open + printer.css(css(printer)));
    }
    ;
    create() {
        const printer = new BasePrinter();
        for (const name of this.componentNames)
            printer.addComponent(name, this.components[name]);
        for (const tagName in this.tags)
            printer.addTag(tagName, this.tags[tagName]);
        for (const regex in this.substitutions)
            printer.addSubstitution(regex, this.substitutions[regex]);
        printer.setOptions(this.options);
        printer.usePalette(this.palette);
        return printer;
    }
    ;
    namespace(namespace) {
        if (typeof namespace !== "string")
            throw new Error("Namespace must be a string.");
        const printer = this.create();
        printer.options.namespaceValue = namespace;
        return printer;
    }
    ;
    print(...stuff) {
        const [text, cleanText] = this.format(...stuff);
        this.write(text, cleanText, LogLevel.log);
        return this;
    }
    ;
    println(...stuff) {
        const [text, cleanText] = this.format(...stuff);
        this.write(text + "\n", cleanText + "\n", LogLevel.log);
        return this;
    }
    ;
    color(val, bg = false) {
        if (!val)
            return "";
        const c = bg ? "bgColor" : "color";
        if (typeof val !== "string")
            return hasAnsi16mStdout ? ansi_styles_1.default[c].ansi16m(...val) : "";
        if (val.startsWith("#")) {
            return hasAnsi16mStdout ? ansi_styles_1.default[c].ansi16m(...ansi_styles_1.default.hexToRgb(val)) : "";
        }
        if (val.startsWith("rgb(") || val.startsWith("rgba(")) {
            const rgb = val.slice(val[3] === "a" ? 5 : 4, -1).split(",").map(Number);
            return hasAnsi16mStdout ? ansi_styles_1.default[c].ansi16m(rgb[0], rgb[1], rgb[2]) : "";
        }
        if (val.startsWith("hsl(") || val.startsWith("hsla(")) {
            const hsl = val.slice(val[3] === "a" ? 5 : 4, -1).split(",").map(Number);
            return hasAnsi16mStdout ? ansi_styles_1.default[c].ansi16m(...(0, utils_1.hslToRgb)(hsl[0], hsl[1], hsl[2])) : "";
        }
        if (val.startsWith("hsv(") || val.startsWith("hsva(")) {
            const hsv = val.slice(val[3] === "a" ? 5 : 4, -1).split(",").map(Number);
            return hasAnsi16mStdout ? ansi_styles_1.default[c].ansi16m(...(0, utils_1.hsvToRgb)(hsv[0], hsv[1], hsv[2])) : "";
        }
        if (val in this.palette && hasAnsi16mStdout)
            return this.color(this.palette[val], bg);
        if (ansi_styles_1.foregroundColorNames.includes(val))
            return ansi_styles_1.default[bg ? "bg" + val[0].toUpperCase() + val.slice(1) : val].open;
        if (val in color_name_1.default) {
            const rgb = color_name_1.default[val];
            if (hasAnsi16mStdout)
                return ansi_styles_1.default[c].ansi16m(rgb[0], rgb[1], rgb[2]);
        }
        return "";
    }
    ;
    css(css) {
        if (typeof css === "string")
            css = (0, utils_1.parseCSS)(css);
        let result = "";
        if (css.font && css.font.color) {
            result += this.color(css.font.color);
            if (css.font.style.italic)
                result += ansi_styles_1.default.italic.open;
            if (css.font.weight >= 600)
                result += ansi_styles_1.default.bold.open;
        }
        if (css.background?.color)
            result += this.color(css.background.color, true);
        if (css.textDecoration?.line?.under)
            result += ansi_styles_1.default.underline.open;
        if (css.textDecoration?.line?.through)
            result += ansi_styles_1.default.strikethrough.open;
        return result;
    }
    ;
    format(...texts) {
        let result = "";
        let cleanResult = "";
        for (let i = 0; i < texts.length; i++) {
            const text = texts[i];
            if (i > 0) {
                result += this.options.sep;
                cleanResult += this.options.sep;
            }
            if (typeof text !== "string") {
                const ins = this.inspect(text);
                result += ins;
                cleanResult += ins;
                continue;
            }
            result += text.replaceAll(/%[cfdioOsv]/g, r => {
                if (i === texts.length - 1) {
                    cleanResult += r;
                    return r;
                }
                const k = r[1];
                i++;
                const val = texts[i];
                if (k === "c")
                    return this.css(val);
                const v = this.inspect(val);
                cleanResult += v;
                return v;
            });
        }
        return [result, cleanResult];
    }
    ;
    inspect(value, rec = new WeakSet, depth = this.options.objectDepth) {
        if (nodeUtil)
            return nodeUtil.inspect(value, false, depth, false);
        switch (typeof value) {
            case "string":
                return JSON.stringify(value);
            case "number":
            case "boolean":
            case "symbol":
            case "undefined":
            case "bigint":
                return String(value);
            case "function":
                return `[Function: ${value.name || "anonymous"}]`;
            case "object":
                if (value === null)
                    return "null";
                if (rec.has(value))
                    return "[Circular]";
                if (depth <= 0)
                    return value.constructor ? `[${value.constructor.name}]` : `[Object]`;
                rec.add(value);
                if (Array.isArray(value)) {
                    if (value.length === 0)
                        return "[]";
                    return `[ ${value.map(v => this.inspect(v, rec, depth - 1)).join(", ")} ]`;
                }
                if (value instanceof Set) {
                    if (value.size === 0)
                        return "Set(0) {}";
                    return `Set(${value.size}) { ${[...value].map(v => this.inspect(v, rec, depth - 1)).join(", ")} }`;
                }
                if (value instanceof Map) {
                    if (value.size === 0)
                        return "Map(0) {}";
                    return `Map(${value.size}) { ${[...value.entries()].map(([k, v]) => `${this.inspect(k, rec, depth - 1)} => ${this.inspect(v, rec, depth - 1)}`).join(", ")} }`;
                }
                if (value instanceof Date)
                    return `Date(${value.toISOString()})`;
                if (value instanceof RegExp)
                    return `RegExp(${value.toString()})`;
                if (value instanceof Error)
                    return value.stack;
                const entries = Object.entries(value);
                if (entries.length === 0)
                    return "{}";
                return `{ ${entries.map(([k, v]) => `${k}: ${this.inspect(v, rec, depth - 1)}`).join(", ")} }`;
        }
    }
    ;
    usePalette(palette) {
        if (typeof palette === "string")
            palette = utils_1.ColorPalettes[palette];
        this.palette = { ...palette };
        return this;
    }
    ;
    makeGlobal(name = "printer") {
        globalVar[name] = this;
        return this;
    }
    ;
    replaceConsole() {
        globalVar.console = this;
        return this;
    }
    ;
    addFile(filename, fs = req("fs")) {
        if (typeof filename !== "string")
            throw new Error("Filename must be a string.");
        if (this.streams.has(filename))
            throw new Error(`File stream "${filename}" already exists.`);
        if (!fs)
            throw new Error("File stream requires 'fs' module.");
        this.streams.set(filename, (text) => fs.appendFileSync(filename, text, { encoding: "utf8" }));
        return this;
    }
    ;
    removeFile(filename) {
        if (typeof filename !== "string")
            throw new Error("Filename must be a string.");
        if (!this.streams.has(filename))
            throw new Error(`File stream "${filename}" does not exist.`);
        this.streams.delete(filename);
        return this;
    }
    ;
    makeLoggerFile(options = {}) {
        const chr = this.options.componentSymbol;
        options = {
            folder: "./logs",
            format: "log-" + chr + "DD-" + chr + "MM-" + chr + "YYYY.log",
            month: "long",
            day: "long", ...options
        };
        this._periodicOptions = options;
        if (this.streams.get(periodicLogger))
            return;
        let currentFile = "";
        let currentStream = null;
        const fs = options.fs || req("fs");
        this.streams.set(periodicLogger, (_, cleanContent) => {
            const chr = this.options.componentSymbol;
            const chrLen = chr.length;
            const options = this._periodicOptions;
            if (!fs.existsSync(options.folder))
                fs.mkdirSync(options.folder);
            const d = new Date;
            const day = d.getDate();
            const month = d.getMonth() + 1;
            const year = d.getFullYear();
            const hours = d.getHours();
            const minutes = d.getMinutes();
            const seconds = d.getSeconds();
            const ms = d.getMilliseconds();
            const date = new Date;
            const ls = {
                date: date.toLocaleString("en", { weekday: options.day }),
                month: date.toLocaleString("en", { month: options.month }),
                D: day, M: month, Y: year, h: hours, m: minutes, s: seconds, S: ms
            };
            let file = typeof options.format === "function" ? options.format() : options.format;
            file = file.replaceAll(new RegExp(`${chr.split("").map(i => `\\${i}`)}(date|month|[DMYShms]+)`, "g"), str => {
                str = str.slice(chrLen);
                if (str === "date" || str === "month")
                    return ls[str];
                const len = str.length;
                str = ls[str[0]].toString().padStart(len, "0");
                if (str.length > len)
                    str = str.slice(str.length - len);
                return str;
            });
            let folder = options.folder;
            if (folder.endsWith("/") || folder.endsWith("\\"))
                folder = folder.slice(0, -1);
            file = folder + "/" + file;
            if (file !== currentFile) {
                if (currentStream)
                    currentStream.close();
                fs.mkdirSync(folder + "/", { recursive: true });
                currentStream = fs.createWriteStream(file, { flags: "a" });
            }
            currentStream.write(cleanContent);
        });
        return this;
    }
    ;
    makeHashedLoggerFile(options = {}) {
        const chr = this.options.componentSymbol;
        options = { folder: "./logs", radix: 16, divide: 3, format: "log-" + chr + "t.log", ...options };
        const fs = options.fs || req("fs");
        if (!fs.existsSync(options.folder))
            fs.mkdirSync(options.folder);
        const format = typeof options.format === "function" ? options.format() : options.format;
        let folder = options.folder;
        if (folder.endsWith("/") || folder.endsWith("\\"))
            folder = folder.slice(0, -1);
        const file = folder + "/" + format.replaceAll(chr + "t", Math.floor(Date.now() / (10 ** options.divide)).toString(options.radix));
        this.addFile(file);
        return this;
    }
    ;
    backspace(count) {
        if (typeof count !== "number" || count < 0)
            throw new Error("Count must be a positive number.");
        const text = "\x1b[" + count + "D" + " ".repeat(count) + "\x1b[" + count + "C";
        this.write(text, "", LogLevel.log);
        return this;
    }
    ;
    cursorUp(count) {
        if (typeof count !== "number" || count < 0)
            throw new Error("Count must be a positive number.");
        const text = "\x1b[" + count + "A";
        this.write(text, "", LogLevel.log);
        return this;
    }
    ;
    cursorDown(count) {
        if (typeof count !== "number" || count < 0)
            throw new Error("Count must be a positive number.");
        const text = "\x1b[" + count + "B";
        this.write(text, "", LogLevel.log);
        return this;
    }
    ;
    cursorLeft(count) {
        if (typeof count !== "number" || count < 0)
            throw new Error("Count must be a positive number.");
        const text = "\x1b[" + count + "D";
        this.write(text, "", LogLevel.log);
        return this;
    }
    ;
    cursorRight(count) {
        if (typeof count !== "number" || count < 0)
            throw new Error("Count must be a positive number.");
        const text = "\x1b[" + count + "C";
        this.write(text, "", LogLevel.log);
        return this;
    }
    ;
    clear() {
        this.write(clearString, "", LogLevel.log);
        return this;
    }
    ;
    addDefaultStream() {
        this.streams.set(this.defaultStream, this.defaultStream);
        return this;
    }
    ;
    removeDefaultStream() {
        this.streams.delete(this.defaultStream);
        return this;
    }
    ;
    removeAllSubstitutions() {
        this.substitutions = {};
        this.parse();
        return this;
    }
    ;
    addDefaultSubstitutions(character = "&") {
        const baseStyles = {
            0: "color: #000000",
            1: "color: #0000AA",
            2: "color: #00AA00",
            3: "color: #00AAAA",
            4: "color: #AA0000",
            5: "color: #AA00AA",
            6: "color: #FFAA00",
            7: "color: #AAAAAA",
            8: "color: #555555",
            9: "color: #5555FF",
            a: "color: #55FF55",
            b: "color: #55FFFF",
            c: "color: #FF5555",
            d: "color: #FF55FF",
            e: "color: #FFFF55",
            f: "color: #FFFFFF",
            l: "font-weight: bold",
            m: "text-decoration: line-through",
            n: "text-decoration: underline",
            o: "font-style: italic",
            r: "",
            t: (p) => "color: " + p.options.currentTag.textColor
        };
        for (const k in baseStyles)
            this.addStyle(character + k, baseStyles[k]);
        return this;
    }
    ;
    get isReading() {
        return !!this.alreadyReading;
    }
    ;
    async readline(question = "", { history = [], allowClear = false, stdin = process.stdin, stdout = process.stdout } = {}) {
        await this.alreadyReading;
        if ("setRawMode" in stdin && typeof stdin.setRawMode === "function")
            stdin.setRawMode(true);
        if ("resume" in stdin && typeof stdin.resume === "function")
            stdin.resume();
        if (typeof question === "function")
            question = question();
        const info = this.readInfo = {
            question,
            cursor: 0,
            text: ""
        };
        let lastText = "";
        let historyIndex = history.length;
        const lineLength = streamsLength.get(stdout) || 0;
        if (lineLength !== 0)
            stdout.write(`\n${question}`);
        else
            stdout.write(question);
        let runFn;
        this.alreadyReading = new Promise(r => {
            stdin.on("data", run);
            runFn = run;
            function run(buf) {
                if (buf[0] == 0x7f) {
                    // ctrl backspace
                    if (info.cursor === 0)
                        return;
                    const index = info.text.lastIndexOf(" ", info.cursor - 1);
                    if (index === -1) {
                        const rest = info.text.slice(info.cursor);
                        stdout.write(`\r${question}${rest}${" ".repeat(info.text.length - rest.length)}\x1b[${info.text.length}D`);
                        info.text = rest;
                        info.cursor = 0;
                    }
                    else {
                        const text = info.text.slice(0, index) + info.text.slice(info.cursor);
                        stdout.write(`\r${question}${text}${" ".repeat(info.text.length - text.length)}\x1b[${info.text.length - index}D`);
                        info.text = text;
                        info.cursor = index;
                    }
                    return;
                }
                let str = buf.toString();
                switch (str) {
                    case "\x03":
                    case "\x04":
                        r(null);
                        break;
                    case "\x1b[A": // up
                    case "\x1b[B": { // down
                        if (str === "\x1b[A") {
                            if (historyIndex === 0)
                                return;
                            historyIndex--;
                        }
                        else {
                            if (historyIndex === history.length)
                                return;
                            historyIndex++;
                        }
                        const current = historyIndex === history.length ? lastText : history[historyIndex];
                        const erase = info.text.length - current.length;
                        stdout.write(`\r${question}${current}${erase > 0 ? " ".repeat(erase) + "\b".repeat(erase) : ""}`);
                        info.text = current;
                        info.cursor = info.text.length;
                        break;
                    }
                    case "\x1b[C": // right
                        if (info.cursor >= info.text.length)
                            return;
                        info.cursor++;
                        stdout.write(`\x1b[1C`);
                        break;
                    case "\x1b[D": // left
                        if (info.cursor === 0)
                            return;
                        info.cursor--;
                        stdout.write(`\x1b[1D`);
                        break;
                    case "\x1b[1~": // home
                        info.cursor = 0;
                        info.text = "";
                        stdout.write(`\r${question}`);
                        break;
                    case "\x1b[2~": // insert
                        break;
                    case "\x1b[1;5D": // ctrl + left
                        if (info.cursor === 0)
                            return;
                        const index = info.text.lastIndexOf(" ", info.cursor - 1);
                        if (index === -1) {
                            stdout.write(`\x1b[${info.cursor}D`);
                            info.cursor = 0;
                        }
                        else {
                            stdout.write(`\x1b[${info.cursor - index}D`);
                            info.cursor = index;
                        }
                        break;
                    case "\x1b[1;5C": // ctrl + right
                        if (info.cursor >= info.text.length)
                            return;
                        const nextIndex = info.text.indexOf(" ", info.cursor + 1);
                        if (nextIndex === -1) {
                            stdout.write(`\x1b[${info.text.length - info.cursor}C`);
                            info.cursor = info.text.length;
                        }
                        else {
                            stdout.write(`\x1b[${nextIndex - info.cursor}C`);
                            info.cursor = nextIndex;
                        }
                        break;
                    case "\x1b[1;2D": // shift + left
                        break;
                    case "\x1b[1;2C": // shift + right
                        break;
                    case "\x1b[1;2A": // shift + up
                        break;
                    case "\x1b[1;2B": // shift + down
                        break;
                    case "\x1b[3~": { // delete
                        if (info.cursor >= info.text.length)
                            return;
                        const rest = info.text.slice(info.cursor + 1);
                        info.text = info.text.slice(0, info.cursor) + rest;
                        stdout.write(`${rest} ${"\b".repeat(rest.length + 1)}`);
                        if (historyIndex === history.length)
                            lastText = info.text;
                        break;
                    }
                    case "\x1b[3;5~": // ctrl + delete
                        if (info.cursor >= info.text.length)
                            return;
                        const nextSpace = info.text.indexOf(" ", info.cursor + 1);
                        if (nextSpace === -1) {
                            const c = info.text.length - info.cursor;
                            stdout.write(`${" ".repeat(c)}\x1b[${c}D`);
                            info.text = info.text.slice(0, info.cursor);
                            info.cursor = info.text.length;
                        }
                        else {
                            const rest = info.text.slice(nextSpace + 1);
                            const c = nextSpace - info.cursor + 1;
                            stdout.write(`${rest}${" ".repeat(c)}\x1b[${c + rest.length}D`);
                            info.text = info.text.slice(0, info.cursor) + rest;
                        }
                        break;
                    case "\b": { // backspace
                        if (info.cursor === 0)
                            return;
                        const rest = info.text.slice(info.cursor);
                        info.text = info.text.slice(0, info.cursor - 1) + rest;
                        info.cursor--;
                        stdout.write(`\b${rest} ${"\b".repeat(rest.length + 1)}`);
                        if (historyIndex === history.length)
                            lastText = info.text;
                        break;
                    }
                    case "\f": // CTRL + L
                        if (allowClear) {
                            stdout.write("\x1b[2J\x1b[0;0H");
                            stdout.write(`${question}${info.text}${"\b".repeat(info.text.length - info.cursor)}`);
                        }
                        break;
                    case "\n":
                    case "\r":
                        r(info.text);
                        const lineLength = streamsLength.get(stdout) || 0;
                        if (lineLength !== 0) {
                            stdout.write(`\x1b[1A\x1b[${lineLength - info.cursor}C`); // move the cursor where it belongs
                        }
                        else
                            stdout.write("\n");
                        break;
                    default:
                        /*if (buf.length !== 1 || buf[0] < 32 || buf[0] > 126) {
                            console.log(buf); for debug
                            return;
                        }*/
                        if (str === "\t")
                            str = "  ";
                        if (info.cursor === info.text.length) {
                            info.text += str;
                            info.cursor += str.length;
                            stdout.write(str);
                        }
                        else {
                            const rest = info.text.slice(info.cursor);
                            info.text = info.text.slice(0, info.cursor) + str + rest;
                            info.cursor += str.length;
                            stdout.write(`${str}${rest} ${"\b".repeat(rest.length + 1)}`);
                        }
                        if (historyIndex === history.length)
                            lastText = info.text;
                        break;
                }
            }
        });
        const response = await this.alreadyReading;
        this.alreadyReading = null;
        this.readInfo = null;
        stdin.removeListener("data", runFn);
        stdin.setRawMode(false);
        stdin.pause();
        return response;
    }
    ;
    count(label = "default") {
        if (!this._counts[label])
            this._counts[label] = 0;
        this._counts[label]++;
    }
    ;
    countReset(label = "default") {
        this._counts[label] = 0;
    }
    ;
    group(...labels) {
        if (isWeb && originalConsole)
            originalConsole.group(...labels);
        else
            this._group++;
    }
    ;
    groupCollapsed(...labels) {
        if (isWeb && originalConsole)
            originalConsole.groupCollapsed(...labels);
        else
            this._group++;
    }
    ;
    groupEnd() {
        if (isWeb && originalConsole)
            originalConsole.groupEnd();
        else
            this._group--;
        if (this._group < 0)
            this._group = 0;
    }
    ;
    table(data, columns) {
        if (typeof data !== "object" || !data)
            throw new TypeError("Data must be an object or an array.");
        let entries = [];
        let keyText = "(index)";
        if (Array.isArray(data)) {
            data.forEach((v, i) => entries.push([i, v]));
        }
        else if (Symbol.iterator in data && typeof data[Symbol.iterator] === "function") {
            for (const [k, v] of data)
                entries.push([k, v]);
            keyText = "(iteration index)";
        }
        else
            entries = Object.entries(data);
        if (columns && (typeof columns === "object" || !Array.isArray(columns)))
            throw new TypeError("Columns must be an array.");
        const map = {};
        const lens = {};
        const keySymbol = Symbol("key");
        const valueSymbol = Symbol("value");
        valueSymbol.toString = () => "Values";
        keySymbol.toString = () => keyText;
        lens[keySymbol] = keyText.length;
        map[keySymbol] = entries.map(i => {
            const r = i[0].toString();
            lens[keySymbol] = Math.max(lens[keySymbol], r.length);
            return r;
        });
        const values = Array(entries.length).fill("");
        let valueLen = "Values".length;
        let anyValue = false;
        const procKey = (k) => {
            k = k.toString();
            map[k] = Array(entries.length);
            for (let i = 0; i < entries.length; i++) {
                const entry = entries[i][1];
                let val = "";
                if (Array.isArray(entry)) {
                    if (entry[k])
                        val = entry[k];
                }
                else if (entry instanceof Map) {
                    if (entry.has(k))
                        val = this.inspect(entry.get(k));
                }
                else if (Symbol.iterator in entry) {
                    for (const [key, value] of entry)
                        if (key === k) {
                            val = this.inspect(value);
                            break;
                        }
                }
                else if (typeof entry === "object" && entry !== null) {
                    if (k in entry)
                        val = this.inspect(entry[k]);
                }
                else {
                    values[i] = this.inspect(entry);
                    valueLen = Math.max(valueLen, values[i].length);
                    anyValue = true;
                }
                map[k][i] = val;
                lens[k] = Math.max(lens[k] || 0, val.length);
            }
        };
        if (columns)
            for (const k of columns)
                procKey(k);
        else
            for (const [key, value] of entries)
                if (key && typeof key === "object") {
                    if (Array.isArray(key))
                        value.forEach((_, k) => procKey(k));
                    else if (Symbol.iterator in key && typeof key[Symbol.iterator] === "function") {
                        for (const k of key)
                            procKey(k);
                    }
                    else
                        for (const k in key)
                            procKey(k);
                }
        if (anyValue) {
            map[valueSymbol] = values;
            lens[valueSymbol] = valueLen;
        }
        const allKeys = [keySymbol, ...Object.keys(map), ...(map[valueSymbol] ? ["Values"] : [])];
        const tag = this.options.defaultTag;
        const drawLine = (left, middle, right, fill) => {
            this.tag(tag, allKeys.map((k, i) => `${i ? middle : left} ${fill.repeat(lens[k])} `) + right);
        };
        drawLine("┌", "┬", "┐", "─");
        this.tag(tag, allKeys.map(k => `│ ${k.toString().padEnd(lens[k], " ")} `) + "│");
        drawLine("├", "┼", "┤", "─");
        for (let i = 0; i < entries.length; i++) {
            this.tag(tag, allKeys.map(k => `│ ${map[k][i].toString().padEnd(lens[k], " ")} `) + "│");
        }
        drawLine("└", "┴", "┘", "─");
        return this;
    }
    ;
    time(label = "default") {
        if (this._times[label])
            this.tag(this.options.defaultWarnTag, `Time '${label}' already exists.`);
        this._times[label] = performance.now();
        return this;
    }
    ;
    timeLog(label = "default", ...args) {
        if (!this._times[label]) {
            this.tag(this.options.defaultWarnTag, `Time '${label}' does not exist.`);
            return;
        }
        const time = performance.now() - this._times[label];
        this.tag(this.options.defaultTag, `${label}: ${time}ms`, ...args);
        return this;
    }
    ;
    timeEnd(label = "default") {
        if (!this._times[label]) {
            this.tag(this.options.defaultWarnTag, `Time '${label}' does not exist.`);
            return;
        }
        const time = performance.now() - this._times[label];
        delete this._times[label];
        this.tag(this.options.defaultTag, `${label}: ${time}ms`);
        return this;
    }
    ;
    profile(profileName) {
        originalConsole?.profile(profileName);
        return this;
    }
    ;
    profileEnd(profileName) {
        originalConsole?.profileEnd(profileName);
        return this;
    }
    ;
    timeStamp(label) {
        originalConsole?.timeStamp(label);
        return this;
    }
    ;
    trace(...args) {
        this._tracing = true;
        this.tag(this.options.defaultTag, ...args);
        this._tracing = true;
        return this;
    }
    ;
}
exports.BasePrinter = BasePrinter;
exports.printer = new BasePrinter()
    .addTag("pass", { text: "PASS", background: "greenBright", textColor: "greenBright" })
    .addTag("fail", { text: "FAIL", background: "redBright", textColor: "redBright", level: LogLevel.error })
    .addTag("error", { text: "ERR!", background: "red", textColor: "red", level: LogLevel.error })
    .addTag("warn", { text: "WARN", background: "yellow", textColor: "yellow", level: LogLevel.warn })
    .addTag("info", { text: "INFO", background: "blue", textColor: "blue", level: LogLevel.info })
    .addTag("debug", { text: "DEBUG", background: "gray", textColor: "gray", level: LogLevel.debug })
    .addTag("notice", { text: "NOTICE", background: "cyan", textColor: "cyan" })
    .addTag("log", { text: "LOG", background: "white", textColor: "white" })
    .addTag("ready", { text: "READY", background: "magenta", textColor: "magenta" })
    .addTag("assert", { text: "ASSERT", background: "gray", textColor: "gray", assert: true })
    .addComponent("tag", TagComponent_1.default)
    .addComponent("date", DateComponent_1.default)
    .addComponent("time", TimeComponent_1.default)
    .addComponent("uptime", UptimeComponent_1.default)
    .addComponent("filename", FileComponent_1.default)
    .addComponent("function", FunctionComponent_1.default)
    .addComponent("line", LineComponent_1.default)
    .addComponent("column", ColumnComponent_1.default)
    .addComponent("namespace", NamespaceComponent_1.default)
    .usePalette("JetBrains")
    .addDefaultSubstitutions();
const brackets = exports.printer.create().setOptions({
    tag: { bold: true, padding: 0, color: "", background: "" },
    date: { background: "", padding: 0 },
    time: { background: "", padding: 0 },
    namespace: {
        padding: 0,
        color: "",
        background: "",
        after: "&t] | ",
        before: "["
    },
    format: "&t$namespace&t[$date&t] | [&t$time&t] [&t$tag&t] > $text"
}).usePalette({});
for (const tag of brackets.getTags()) {
    brackets.getTag(tag).background = "";
    brackets.getTag(tag).padding = 0;
}
globalVar.Printer = exports.printer;
exports.default = exports.printer;
